var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","padding":"8px"}},[_c('video',{staticStyle:{"width":"100%","height":"400px"},attrs:{"src":_vm.src,"controls":"","autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }